<div class="customer-merge">
  <div class="merge-header">Merge Customer Profiles</div>

  <div class="merge-body">

    <ng-container *ngIf="!candidate">
      <div class="hint">
        Search for the duplicate profile to merge with
        <strong>{{customer.firstName}} {{customer.lastName}}</strong>.
      </div>
      <input class="search" type="text" placeholder="Search by name, email, or phone"
             [(ngModel)]="searchText" (ngModelChange)="searchChanged()" autofocus />

      <div class="results" *ngIf="results">
        <div class="no-results" *ngIf="results.length === 0 && !searching">No matching customers or users.</div>
        <div class="result" *ngFor="let result of results" (click)="selectCandidate(result)">
          <div class="result-name">
            {{result.fullName || result.email || result.telephone}}
            <span class="staff-badge" *ngIf="result.type === 'user'">STAFF</span>
          </div>
          <div class="result-detail">{{result.email}}</div>
          <div class="result-detail">{{result.telephone | rf:'phone'}}</div>
          <div class="result-detail">Added {{result.timeAdded | rf:'date'}}</div>
        </div>
      </div>
      <div class="searching" *ngIf="searching">Searching&hellip;</div>
    </ng-container>

    <ng-container *ngIf="candidate">
      <div class="hint" *ngIf="!candidateIsStaff">
        Choose which profile to keep. Blank fields on the kept profile fill in from the
        other, and the other profile's purchases, transactions, loyalty balances, and
        notes all move to the kept profile before it is deactivated.
      </div>
      <div class="hint" *ngIf="candidateIsStaff">
        Staff profiles always survive a merge: this customer profile's purchases,
        transactions, loyalty balances, and notes move to the staff user, blank fields
        on the staff record fill in from the customer, and the customer profile is
        deactivated.
      </div>

      <div class="compare">
        <div class="compare-col" [class.keep]="keep === 'current'"
             [class.locked]="candidateIsStaff" (click)="setKeep('current')">
          <div class="keep-flag">{{keep === 'current' ? 'KEEP THIS PROFILE' : 'Merged away'}}</div>
          <div class="compare-name">{{customer.firstName}} {{customer.lastName}}</div>
          <div class="compare-row"><label>Email</label><span>{{customer.email || '—'}}</span></div>
          <div class="compare-row"><label>Phone</label><span>{{(customer.telephone | rf:'phone') || '—'}}</span></div>
          <div class="compare-row"><label>Added</label><span>{{customer.timeAdded | rf:'date'}}</span></div>
          <div class="compare-row"><label>Last Purchase</label><span>{{(customer.timePurchased | rf:'date') || '—'}}</span></div>
        </div>
        <div class="compare-col" [class.keep]="keep === 'candidate'" (click)="setKeep('candidate')">
          <div class="keep-flag">{{keep === 'candidate' ? 'KEEP THIS PROFILE' : 'Merged away'}}</div>
          <div class="compare-name">
            {{candidate.fullName || candidate.email || candidate.telephone}}
            <span class="staff-badge" *ngIf="candidateIsStaff">STAFF</span>
          </div>
          <div class="compare-row"><label>Email</label><span>{{candidate.email || '—'}}</span></div>
          <div class="compare-row"><label>Phone</label><span>{{(candidate.telephone | rf:'phone') || '—'}}</span></div>
          <div class="compare-row"><label>Added</label><span>{{candidate.timeAdded | rf:'date'}}</span></div>
          <div class="compare-row"><label>Last Purchase</label><span>{{(candidate.timePurchased | rf:'date') || '—'}}</span></div>
        </div>
      </div>

      <div class="back-link" (click)="clearCandidate()">&larr; Choose a different profile</div>
    </ng-container>

    <div class="error" *ngIf="error">{{error}}</div>
  </div>

  <div class="merge-buttons">
    <div class="merge-button" (click)="cancel()">Cancel</div>
    <div class="merge-button confirm" [class.disabled]="!candidate || merging" (click)="confirmMerge()">
      {{merging ? 'Merging…' : 'Merge Profiles'}}
    </div>
  </div>
</div>
